import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import Links from 'ui/components/generic/Links'
import { Relative } from 'ui/styles/utils'
import './leds.css'

const Wrapper = styled.div`
  position: relative;
  padding: 50px 0 75px;
  overflow: hidden;

  ${media.lg`
    padding: 100px 0 150px;
    margin: 50px 0;
  `}
`

const Text = styled.div`
  margin-bottom: 30px;

  font-weight: 300;
  font-size: 20px;
  line-height: 22px;
  color: ${props => props.theme.colors.text};
`

const Header = Text.extend`
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 500;
  margin-top: 30px;
  color: ${props => props.theme.colors.tones.dark};
`

const TextCol = styled.div`
  position: relative;
  margin-bottom: 30px;
  border-top: 1px solid black;

  ${media.lg`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 650px;
    margin-bottom: 0;
  `}
`

const ImageCol = styled.div`
  img {
    width: 100%;
  }
`

const Background = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 50px;

  z-index: 0;

  * {
    height: 100%;
  }
`

{/* <style>
@keyframes blink {</p>
<p> 0% {<br />opacity: 100;<br />}<br />  50% {<br />opacity: 0;<br /> }</p>
<p> 100%<br />   {opacity: 100;<br />   }<br /> }<br /> </style> 
background-color: rgba(255, 0, 0, 0.856); width: 15px; height: 15px; border-radius: 100%; margin: auto; vertical-align: middle; animation: blink 2s infinite;"
0.911
*/}

const Grey = styled.div`
  position: absolute;
  left: -20px;
  right: auto;
  height: calc(100% - (100vw - 60px));
  top: 0px;
  width: 100vw;

  background-color: ${props => props.theme.colors.tones.lightest};

  ${media.sm`
    left: -50px;
    height: 100%;
  `}

  ${media.md`
    left: ${props => props.orientation === 'left' ? '0px' : 'auto'};
    right: ${props => props.orientation === 'left' ? 'auto' : '0px'};
    height: 100%;
  `}
`

const Tabler = styled.tr`
border-bottom: 1px solid #eaeaea;
`

const CellLabel = styled.td`
text-align: center; padding-top: 15px;
`

const CellContent = styled.td`
vertical-align: top;
`
const Dot = styled.div`
background-color: rgba(106, 185, 3, 0.911);
vertical-align: middle;
width: 15px;
height: 15px; 
border-radius: 100%; 
margin: auto;
`

class Leds extends Component {
  render() {
    const { header, buttons, image, orientation } = this.props

    return (
      <Wrapper>
        <Background>
          <Container fluid>
            <Row>
              <Col md={9} mdOffset={orientation === 'left' ? 3 : 0}>
                <Relative>
                  <Grey orientation={orientation} />
                </Relative>
              </Col>
            </Row>
          </Container>
        </Background>
        <Container fluid>
          <Row>
            <Col
              md={4}
              mdOffset={1}
              order={orientation === 'left' ? 2 : 1}
            >
              <TextCol>
                <Header>{header}</Header>
                <Text>
                  <table style={{ width: "100%" }}>
                    <tbody>
                      <Tabler>
                        <CellLabel>Power</CellLabel>
                      </Tabler>
                      <Tabler>
                        <td><Dot/></td>
                        <CellContent>Power on the box</CellContent>
                      </Tabler>
                      <Tabler>
                        <CellLabel>Status</CellLabel>
                      </Tabler>
                      <Tabler>
                        <td style={{textAlign: "center"}}>
                          <Dot className='blink'/></td>
                        <CellContent>No internet connection</CellContent>
                      </Tabler>
                      <Tabler>
                        <td style={{textAlign: "center"}}>
                          <Dot/>
                        </td>
                        <CellContent>Internet connection OK</CellContent>
                      </Tabler>
                      <Tabler>
                        <td style={{textAlign: "center"}}>
                          <Dot className='red blink'/>
                        </td>
                        <CellContent>Internal memory full</CellContent>
                      </Tabler>
                      <Tabler>
                        <td style={{textAlign: "center", verticalAlign: "middle"}}>
                            <Dot className='red'/></td>
                        <CellContent>Internal error</CellContent>
                      </Tabler>
                    </tbody>
                  </table>
                </Text>
                <Links links={buttons} color="primary" />
              </TextCol>
            </Col>
            <Col
              md={5}
              mdOffset={1}
              alignSelf="center"
              order={orientation === 'left' ? 1 : 2}
            >
              <ImageCol>
                <img src={image.sourceUrl} alt={image.altText} />
              </ImageCol>
            </Col>
          </Row>
        </Container>
      </Wrapper>
    )
  }
}

export default Leds



// WEBPACK FOOTER //
// ./src/ui/components/modules/Leds/index.js